import React from "react";
import { Link } from "react-router-dom";
import { Grid, Box, Card, Stack, Typography, Button } from "@mui/material";

import { PageContainer } from "../common";
import { FormLabel, TextField } from "../common/forms";

const AuthForgotPassword = () => {
  return (
    <>
      <Stack mt={4} spacing={2}>
        <FormLabel htmlFor="reset-email">이메일 입력</FormLabel>
        <TextField id="reset-email" variant="outlined" fullWidth />

        <Button
          color="primary"
          variant="contained"
          size="large"
          fullWidth
          component={Link}
          to="/"
        >
          비밀번호 찾기
        </Button>
        <Button
          color="primary"
          size="large"
          fullWidth
          component={Link}
          to="/signin"
        >
          로그인하기
        </Button>
      </Stack>
    </>
  );
};

const FindPassword = () => {
  return (
    <PageContainer>
      <Box
        sx={{
          position: "relative",
          "&:before": {
            content: '""',
            background: "radial-gradient(#d2f1df, #d3d7fa, #bad8f4)",
            backgroundSize: "400% 400%",
            animation: "gradient 15s ease infinite",
            position: "absolute",
            height: "100%",
            width: "100%",
            opacity: "0.3"
          }
        }}
      >
        <Grid
          container
          spacing={0}
          justifyContent="center"
          sx={{ height: "100vh" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            lg={4}
            xl={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Card
              elevation={9}
              sx={{ p: 4, zIndex: 1, width: "100%", maxWidth: "500px" }}
            >
              <Typography
                color="textSecondary"
                textAlign="center"
                variant="subtitle2"
                fontWeight="400"
              >
                비밀번호 찾기 페이지 입니다. 어떤 방법으로 찾을지 확인 후
                적용합니다.
              </Typography>
              <AuthForgotPassword />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default FindPassword;
